import styled from "styled-components";

const Container = styled.div`
    border-top: 1px solid #e6e8ed;
    margin-bottom: 100px;
`;

const Wrapper = styled.div`
    display: flex;
    justify-content: space-between;
    /* max-width: 1200px; */
    padding: 0 30px;
    margin: auto;

    @media all and (max-width:992px){
        padding: 10px;
    }
`;

const MenuItemsBox = styled.div`
    display: flex;
    margin-top: 15px;

    .item-el{
        font-size: 14px;
        font-weight: 700;
        cursor: pointer;
    }

    .item-el:first-child::after{
        content: '|';
        font-weight: 500;
        color: #a1a1a1;
        margin-left: 3px;
        margin-right: 3px;
    }

    @media all and (max-width:992px){
        .item-el{
            font-size: 10px;
            font-weight: 700;
            cursor: pointer;
        }
    }
`;

const ComponyInfoBox = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-top: 15px;
    max-width: 750px;
    .item-el{
        margin-top: 1px;
        margin-bottom: 1px;
        margin-right: 10px;
        font-size: 12px;
        color:#52565d;
    }

    @media all and (max-width:992px){
        flex-direction: column;
        align-items: flex-start;
        max-width: inherit;
        /* margin: 5.55556vw 0 0; */
        font-size: 3.05556vw;
        color: #9da1a8;

        .item-el{
            margin-top: 2px;
            margin-bottom: 2px;
            margin-right: 10px;
            font-size: 10px;
        }
    }
`;

const Copyright = styled.div`
    margin-top: 15px;
    font-size: 12px;
    color:#222;

    @media all and (max-width:992px){
        font-size: 10px;
    }
`;
const FooterMain = () => {
    return (
        <>
            <Container>
                <Wrapper>
                    <div>
                        <MenuItemsBox>
                            <div className='item-el'><a href='https://assets.sellertool.io/consent_form/privacy_policy_v1.html' target="_blank" rel="noreferrer">개인정보처리방침</a></div>
                            <div className='item-el'><a href='https://assets.sellertool.io/consent_form/service_terms_v1.html' target="_blank" rel="noreferrer">이용약관</a></div>
                        </MenuItemsBox>
                        <ComponyInfoBox>
                            <div className="item-el">상호명: (주)피아르홀딩스</div>
                            <div className="item-el">주소: 서울특별시 영등포구 양산로 91 리드원센터 1305호</div>
                            <div className="item-el">사업자등록번호: 137-87-02941</div>
                            <div className="item-el">통신판매업 신고: 제 2023-서울영등포-2189 호</div>
                            <div className="item-el">고객센터: 02-338-9464</div>
                            <div className="item-el">이메일: help@piaar.co.kr</div>
                            <div className="item-el">대표: 변용호</div>
                            <div className="item-el">개인정보관리책임자: 박세훈</div>
                        </ComponyInfoBox>
                        <Copyright>
                            Copyright ⓒ 2023 All rights reserved by Piaar Holdings Co.
                        </Copyright>
                    </div>
                </Wrapper>
            </Container>
        </>
    );
}

export default FooterMain;